import React, { useState,useEffect } from 'react';
import Modal from 'react-modal';
import './UserInfoModal.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import LoadingIcon from '../LoadingIcon/LoadingIcon';
import GoogleAuth from '../GoogleAuth/GoogleAuth';


const UserInfoModal = ({ translatedValue, isOpen, onRequestClose, appointmentDetails }) => {
  // Loading Icon State
  const [isLoading, setLoading] = useState(false);

  //translator hook react-i18next
  const { t } = useTranslation(); // Initialize the useTranslation hook

  // State variables for user input
  const [nimi, setNimi] = useState('');
  const [puhelin, setPuhelin] = useState('');
  const [ssno, setSsno] = useState('');
  const [sahkoposti, setSahkoposti] = useState('');
  const [lahiosoite, setLahiosoite] = useState('');
  const [postinro, setPostinro] = useState('');
  const [toimipaikka, setToimipaikka] = useState('');
  const [lisatiedot, setLisatiedot] = useState('');
  const url = "babeweb.trafore.com";
  const ssl = "https";

  //States for checking input fields and checkboxes

  const [tietosuoja, setTietosuoja] = useState(false);

  // Handler functions for input field checks and checkbox check

    const handleTietosuojaChange = () => {
      setTietosuoja(!tietosuoja); // Toggle the value of tietosuoja
    };

  // Check if appointmentDetails is not null before accessing its properties
  const appointmentDate = appointmentDetails?.date || 'N/A';
  const appointmentTime = appointmentDetails?.time || 'N/A';
  const appointmentTreatment = appointmentDetails?.treatment || 'N/A';
  const appointmentDoctor = appointmentDetails?.doctorname || 'N/A';
  const doctorId = appointmentDetails?.id || 'N/A';

  const addSecondsToTime = (formattedTime) => {
    // Check if the formatted time string includes minutes and hours
    if (formattedTime.match(/^\d{1,2}:\d{1,2}$/)) {
        // Extract hours and minutes from the formatted time string
        const [hours, minutes] = formattedTime.split(':').map(Number);

        // Check if the extracted values are valid
        if (!isNaN(hours) && !isNaN(minutes)) {
            // Add seconds to the time string with leading zeros for minutes
            const timeWithSeconds = `${hours}:${minutes < 10 ? '0' + minutes : minutes}:00`;
            return timeWithSeconds;
        }
    }

    // Return the original formatted time if it already includes seconds or doesn't match the expected format
    return formattedTime;
};

console.log("doctor id", appointmentDoctor);

const timeWithSeconds = addSecondsToTime(appointmentTime);


const formatTimeWithoutLeadingZero = (formattedTime) => {
  // Check if the formatted time string has a colon
  if (formattedTime.includes(':')) {
      // Split the time into hours, minutes, and seconds
      const [hours, minutes, seconds = 0] = formattedTime.split(':').map(Number);

      // Check if the extracted values are valid
      if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
          // Format the time string without leading zeros
          const timeWithoutLeadingZero = `${hours < 10 ? '0' : ''}${hours}.${minutes < 10 ? '0' : ''}${minutes}.${seconds < 10 ? '0' : ''}${seconds}`;
          return timeWithoutLeadingZero;
      }
  }

  // Return the original formatted time if parsing fails or no colon is found
  return formattedTime;
};




  // Example usage
  const timeWithoutLeadingZero = formatTimeWithoutLeadingZero(appointmentTime);


  // Variables for database checks
  const [foundCount, setFoundCount] = useState(0);
  const [recordId, setRecordId] = useState('');

  const [isButtonDisabled, setButtonDisabled] = useState(false);

  // add records json variable

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split('.');
    const dateObject = new Date(`${year}-${month}-${day}`);
    const formattedDate = `${dateObject.getMonth() + 1}/${dateObject.getDate()}/${dateObject.getFullYear()}`;
    return formattedDate;
  }

  const details = {
    "Nimi": nimi,
    "ssno": ssno,
    "Puhelin": puhelin,
    "Email": sahkoposti,
    "Lahiosoite": lahiosoite,
    "Postinumero": postinro,
    "Postitoimipaikka": toimipaikka,
    "Lisatiedot": lisatiedot,
    "Paivamaara": convertDateFormat(appointmentDate),
    "Hoidonnimi": appointmentTreatment,
    "Laakarinimi": appointmentDoctor,
    "Kellonaika": timeWithoutLeadingZero,
    "id": doctorId
  };

  console.log("aika joka tulee sisään", appointmentTime);
  console.log("Aika joka lähtee ulos", timeWithoutLeadingZero);
  console.log("qwedqwfqw", timeWithSeconds);
  
  // Convert the date format and store it in another variable
  const formattedAppointmentDate = convertDateFormat(appointmentDate);
  
  // Now, formattedAppointmentDate contains the date in the format 'MM/DD/YYYY'
  console.log(formattedAppointmentDate);
  console.log(appointmentDate)

  // Appointment sending state variables
  const [sendAuthToken, setSendAuthToken] = useState(null);

  const handleInputChange = (event) => {
    // Update the corresponding state variable based on input field name
    const { name, value } = event.target;
    switch (name) {
      case 'nimi':
        setNimi(value);
        break;
      case 'puhelin':
        setPuhelin(value);
        break;
      case 'ssno':
        setSsno(value);
        break;
      case 'sahkoposti':
        setSahkoposti(value);
        break;
      case 'lahiosoite':
        setLahiosoite(value);
        break;
      case 'postinro':
        setPostinro(value);
        break;
      case 'toimipaikka':
        setToimipaikka(value);
        break;
      case 'lisatiedot':
        setLisatiedot(value);
        break;
      default:
        break;
    }
  };

///
/// Appointment sending logic starts here
///

const deleteFreeTime = async (authToken, recordId) => {
  try {
    const deleteResponse = await axios.post(
      `${ssl}://${url}:3001/deletefreetime`,
      {
        authToken,
        recordId,
      }
    );
    console.log('Delete Response:', deleteResponse.data);
  }
  catch (error) {
    console.error('Error:', error);
  }
}

const addAppointment = async (authToken, details) => {
  try {
    const addResponse = await axios.post(
      `${ssl}://${url}:3001/addappointment`,
      {
        authToken,
        details,
      }
    );
    console.log('Delete Response:', addResponse.data);
  }
  catch (error) {
    console.error('Error:', error);
  }
}

const handleAuthentication = async () => {

  var regexName = /^[a-zA-Z- öäåÖÄÅ]+$/;
  var regexPhone = /^[0-9+ ]+$/;
  var regexEmail = /^$|^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var regexAddress = /^$|^[a-zA-Z0-9\s.]+$/;
  var regexZipCode = /^$|^[0-9]+$/;
  var regexPostOffice = /^$|^[a-zA-Z\s-]+$/;


  if (nimi === "") {
      alert(t('kirjoita_nimesi'));
      return;
  } else if (!regexName.test(nimi)) {
      alert(t('nimi_vaarassa_muodossa'));
      return;
  }

  if (puhelin === "") {
      alert(t('kirjoita_puhelin'));
      return;
  } else if (!regexPhone.test(puhelin)) {
      alert(t('puhelin_vaarassa_muodossa'));
      return;
  }

  if (!regexEmail.test(sahkoposti)) {
      alert(t('sahkoposti_vaarassa_muodossa'));
      return;
  }

  if (!regexAddress.test(lahiosoite)) {
      alert(t('osoite_vaarassa_muodossa'))
      return;
  }

  if (!regexZipCode.test(postinro)) {
      alert(t('postinumero_vaarassa_muodossa'))
      return;
  }

  if (!regexPostOffice.test(toimipaikka)) {
      alert(t('postitoimipaikka_vaarassa_muodossa'))
      return;
  }

  if (!tietosuoja) {
    alert(t('hyvaksy_tietosuoja'));
    return;
  }

  setButtonDisabled(true);
  setLoading(true);
  try {
    await new Promise(resolve => setTimeout(resolve, 1500));
    setButtonDisabled(false);


    // Authenticate and get the token
    const authResponse = await axios.post(
      `${ssl}://${url}:3001/authenticate`,
      {},
    );

    // Assuming the token is returned in the 'token' property
    const authToken = authResponse.data.token;

    // Check if the token is successfully retrieved
    if (authToken) {
      setSendAuthToken(authToken);

      const findQuery = [
        { "NAME": appointmentTreatment,
          "DOCTORNAME": appointmentDoctor,
          "TIME": timeWithSeconds,
          "DATETIME": formattedAppointmentDate
        },
      ];

      console.log("find query", findQuery);

      // Now, make the findonetime request with the token
      const findResponse = await axios.post(
        `${ssl}://${url}:3001/findonetime`,
        {
          authToken,
          findQuery,
        }
      );

      console.log('RecordId', findResponse.data.response.data[0].recordId);
      console.log('FoundCount', findResponse.data.response.dataInfo.foundCount);
      const newRecordId = findResponse.data.response.data[0].recordId;
      setRecordId(newRecordId);
  
      const newFoundCount = findResponse.data.response.dataInfo.foundCount;
  
      console.log('Previous FoundCount:', foundCount);
  
      if (newFoundCount === 1) {
        console.log("päästiin tähän saakka");
        await deleteFreeTime(authToken, newRecordId); // Pass newRecordId to deleteFreeTime
        await addAppointment(authToken, details);
        // Update foundCount after deleting free time
        setFoundCount(0);
        setLoading(false);
        alert("Olet varannut ajan \n" + appointmentTreatment + "\n" + appointmentDoctor + "\n" + appointmentDate + "\n" + appointmentTime);
        window.location.reload();
      }
    } else {
      console.error('Authentication failed: Token not received.');
      alert("Virhe varauksessa");
    }
  } catch (error) {
    console.error('Error:', error);
    console.log("erorrririi")
    alert("Aika on mennyt")
    setButtonDisabled(false);
    window.location.reload();
    setLoading(false);
  }
};



console.log("testi", sendAuthToken);


///
/// Appointment sending logic stops here
///


const someDetails = {
  Nimi: nimi,
  ssno: ssno,
  Puhelin: puhelin,
  Email: sahkoposti,
  Lahiosoite: lahiosoite,
  Postinumero: postinro,
  ostitoimipaikka: toimipaikka,
  Lisatiedot: lisatiedot,
  DATETIME: formattedAppointmentDate,
  NAME: appointmentTreatment,
  DOCTORNAME: appointmentDoctor,
  TIME: timeWithSeconds,
  id: doctorId
};

useEffect(() => {
  const timeoutId = setTimeout(() => {
    setButtonDisabled(false);
  }, 1500);

  // Cleanup function to clear the timeout in case the component unmounts
  return () => clearTimeout(timeoutId);
}, [isButtonDisabled]);

return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="User Information Modal"
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          // Add any other styles as needed
        },
      }}
    >
      {/* Add your modal content here */}
      <h2>{t('olet_varaamassa_aikaa')}</h2>
      {isLoading && <LoadingIcon />}
      <p className="treatment-info">{translatedValue}</p>
      <p className="doctor-info">{appointmentDate}. klo {appointmentTime} ({appointmentDoctor})</p>
      <p style={{ fontSize: 'smaller' }}>{t('pakolliset_kentat')}</p>
  
      {/* Input fields for user information */}
      <label className="input-label">
        {t('nimi')}
        <input type="text" name="nimi" value={nimi} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('sosiaaliturvatunnus')}
        <input type="text" name="ssno" value={ssno} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('puhelin')}
        <input type="text" name="puhelin" value={puhelin} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('sahkoposti')}
        <input type="text" name="sahkoposti" value={sahkoposti} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('lahiosoite')}
        <input type="text" name="lahiosoite" value={lahiosoite} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('postinumero')}
        <input type="text" name="postinro" value={postinro} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('postitoimipaikka')}
        <input type="text" name="toimipaikka" value={toimipaikka} onChange={handleInputChange} className="input-field" />
      </label>
      <label className="input-label">
        {t('lisatiedot')}
        <textarea name="lisatiedot" value={lisatiedot} onChange={handleInputChange} className="input-field" maxLength={200}/>
      </label>
      <label className="input-label">
          <input type="checkbox" name="tietosuoja" checked={tietosuoja} onChange={handleTietosuojaChange}/>
          {t('hyvaksyn')} <a href="link_to_privacy_policy">tietosuojaehdot</a>
      </label>
  
      <button onClick={onRequestClose} className="close-button">X</button>
      

      <button className="submit-button" onClick={handleAuthentication} disabled={isButtonDisabled}>
        {t('varaa_aika')}
      </button>

      <button className="cancel-button" onClick={onRequestClose}>
        {t('peruuta')}
      </button>
      <GoogleAuth detailsAppointment={someDetails} ssno={ssno} tietosuoja={tietosuoja}/>
    </Modal>
  );
  
};

export default UserInfoModal;
